import(/* webpackMode: "eager" */ "/calcom/apps/web/app/global-error.tsx");
